import React from "react";
import { Helmet } from "react-helmet";

export const Head = ({ title }) => {
  return (
    <>
      <Helmet>
        <title>{title} | Peduli TBC</title>
      </Helmet>
    </>
  );
};
